// Load libraries needed to polyfill ES2015
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import * as React from 'react';
import { render } from 'react-dom';
import 'regenerator-runtime/runtime';
// Load the stylesheets
import '../css/custom.less';
import App from './App';
import config from './services/config';

// Temporary dispatch stub until we implement react-redux in existing KO viewmodels/migrate them
function dispatch(action) {
  if (typeof action === 'function') {
    return action(dispatch);
  }

  console.log('Action: ', action);
  return action;
}
(window as any).dispatch = dispatch;

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault(config.timezone);

render(<App />, document.getElementById('app'));
